<template lang="pug">
    el-drawer.drawer(direction='rtl' type='primary' :modal='false' @open='getCourseDetail' :visible.sync='courseOption.courseDetail.showDetail')
        h2 {{ detailedCourse.cname }}
        br
        el-link(:href='`https://timetable.nctu.edu.tw/?r=main/crsoutline&Acy=109&Sem=1&CrsNo=${detailedCourse.id}&lang=zh-tw`')
            h2 前往查看課程詳細資料
        br
        el-tag(:type='selectTypeKey[detailedCourse.type]' size='mini' effect='dark' disable-transitions='' v-show='detailedCourse.credit === 0')
            | {{ detailedCourse.type + '0 學分' }}
        el-tag(:type='selectTypeKey[detailedCourse.type]' size='mini' effect='dark' disable-transitions='' v-for='v of Array(detailedCourse.credit).keys()' :key='v')
            | {{ detailedCourse.type }}
        br
        p {{detailedCourse.memo}}
        el-tag(type='info' size='large' effect='dark' disable-transitions='' v-for='v of filterField(detailedCourse)' :key='v')
            | {{ v }}
        el-tabs(v-model='activeCollapse')
            el-tab-pane(label='課程完整資訊' name='1')
                el-tab-pane(v-if='discuss.title' label='課程心得' name='2')
        iframe(v-if="activeCollapse==='1'" width='100%' height='100%' :src='`https://timetable.nctu.edu.tw/?r=main/crsoutline&Acy=109&Sem=1&CrsNo=${detailedCourse.id}&lang=zh-tw`')
        div(v-else='')
            | &#x8AB2;&#x7A0B;&#x5FC3;&#x5F97; from NCTU+
            h3
                | {{ discuss.title }} - {{ discuss.user_name }}
            a {{ &apos;https://plus.nctu.edu.tw/discusses/&apos; + discuss.id }}
            div
                | {{ discuss.content }}

</template>
<script>
// import axios from 'axios'

export default {
  name: 'CourseDetailDrawer',
  data() {
    return {
      discuss: {},
      activeCollapse: '1'
    }
  },
  computed: {
    detailedCourse() {
      return this.courseOption.courseDetail.showCourse ?? {}
    },
    selectTypeKey() {
      return {
        '必修': 'warning',
        '選修': '',
        '通識': 'danger',
      }
    }
  },
  methods: {
    async getCourseDetail() {
      this.discuss = this.getDiscuss()
      if (!this.discuss) {
        this.discuss = {}
      }
      // let timetableLink = `https://timetable.nctu.edu.tw/?r=main/crsoutline&Acy=109&Sem=1&CrsNo=${this.detailedCourse.id}&lang=zh-tw`
      // let resp = await axios.get(this.requestsProxy + timetableLink)
      // // console.log(resp.data)
      // return resp.data
    },
    getDiscuss() {
      let discuss = this.$store.state.coursesDiscuss[this.detailedCourse.code]
      console.log(discuss)
      return discuss
    },
    filterField(course) {
      let showAttr = {
        'teacher': '教授: ',
        'dep_cname': '系所: ',
        'memo': '',
        'reg_num': '登記人數: ',
        'rawTimeslot': '時段: ',
        'hours': '時數: ',
        'depType': '',
        'id': '永久課號: ',
        'location': '地點: ',
      }
      let displayCourse = []
      for (let attr in showAttr) {
        let value = course[attr]
        if (value) {
          displayCourse.push(`${showAttr[attr]} ${course[attr]}`)
        }
      }
      // console.log(Object.keys(course), Object.values(course));
      return displayCourse
    },
    selectType(tag) {
      return this.selectTypeKey[tag]
    },
  }
}
</script>
<style>
/*.drawer {*/
/*  background-color: rgba(255, 255, 255, 0);*/
/*}*/
</style>
